import React, { useState } from 'react';
import { AudioSegment } from '../types';

interface SegmentEditorProps {
  segments: AudioSegment[];
  currentSegment: AudioSegment | null;
  onSegmentUpdate: (segment: AudioSegment) => void;
  onSegmentDelete: (segmentId: string) => void;
  onSegmentAdd: () => void;
  onSegmentSelect: (segment: AudioSegment) => void;
  onPlaySegment: (segment: AudioSegment) => void;
}

const SegmentEditor: React.FC<SegmentEditorProps> = ({
  segments,
  currentSegment,
  onSegmentUpdate,
  onSegmentDelete,
  onSegmentAdd,
  onSegmentSelect,
  onPlaySegment
}) => {
  const [editingSegment, setEditingSegment] = useState<string | null>(null);

  const formatTime = (time: number) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    const milliseconds = Math.floor((time % 1) * 1000);
    return `${minutes}:${seconds.toString().padStart(2, '0')}.${milliseconds.toString().padStart(3, '0')}`;
  };


  const handleTextChange = (segmentId: string, newText: string) => {
    const segment = segments.find(s => s.id === segmentId);
    if (segment) {
      onSegmentUpdate({ ...segment, text: newText });
    }
  };


  const handleSegmentClick = (segment: AudioSegment) => {
    onSegmentSelect(segment);
    setEditingSegment(segment.id);
  };

  return (
    <div className="segments-section">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', direction: 'rtl' }}>
        <h3>مقاطع الصوت ({segments.length})</h3>
        <button onClick={onSegmentAdd} className="btn btn-primary">
          إضافة مقطع
        </button>
      </div>

      {segments.length === 0 ? (
        <p>لم يتم تحميل مقاطع. ارفع ملف JSON أو أضف مقاطع يدوياً.</p>
      ) : (
        <div>
          {segments.map((segment) => (
            <div
              key={segment.id}
              className={`segment-item ${currentSegment?.id === segment.id ? 'active' : ''}`}
              style={{
                backgroundColor: currentSegment?.id === segment.id ? '#e3f2fd' : 'transparent',
                border: currentSegment?.id === segment.id ? '2px solid #007bff' : '1px solid #eee'
              }}
            >
              <div className="segment-time">
                {editingSegment === segment.id ? (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '5px', direction: 'rtl' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <label style={{ fontSize: '12px', color: '#666' }}>البداية</label>
                      <input
                        type="number"
                        value={segment.startTime.toFixed(3)}
                        onChange={(e) => {
                          const time = parseFloat(e.target.value) || 0;
                          onSegmentUpdate({ ...segment, startTime: Math.max(0, time) });
                        }}
                        step="0.1"
                        min="0"
                        style={{ 
                          width: '80px', 
                          textAlign: 'center',
                          direction: 'ltr',
                          borderRadius: '4px',
                          border: '1px solid #ddd',
                          padding: '4px'
                        }}
                      />
                    </div>
                    <span style={{ margin: '0 5px', fontSize: '16px' }}>-</span>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <label style={{ fontSize: '12px', color: '#666' }}>النهاية</label>
                      <input
                        type="number"
                        value={segment.endTime.toFixed(3)}
                        onChange={(e) => {
                          const time = parseFloat(e.target.value) || 0;
                          onSegmentUpdate({ ...segment, endTime: Math.max(segment.startTime + 0.1, time) });
                        }}
                        step="0.1"
                        min={segment.startTime + 0.1}
                        style={{ 
                          width: '80px', 
                          textAlign: 'center',
                          direction: 'ltr',
                          borderRadius: '4px',
                          border: '1px solid #ddd',
                          padding: '4px'
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <span onClick={() => handleSegmentClick(segment)} style={{ cursor: 'pointer' }}>
                    {formatTime(segment.startTime)} - {formatTime(segment.endTime)}
                  </span>
                )}
              </div>

              <textarea
                className="segment-text"
                value={segment.text}
                onChange={(e) => handleTextChange(segment.id, e.target.value)}
                onFocus={() => setEditingSegment(segment.id)}
                onBlur={() => setEditingSegment(null)}
                rows={2}
                placeholder="أدخل نص النسخ..."
              />

              <div>
                <button
                  onClick={() => onPlaySegment(segment)}
                  className="btn btn-secondary"
                  style={{ marginLeft: '5px' }}
                >
                  تشغيل
                </button>
                <button
                  onClick={() => onSegmentDelete(segment.id)}
                  className="btn"
                  style={{ backgroundColor: '#dc3545', color: 'white' }}
                >
                  حذف
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SegmentEditor;